var React = require('react');

function ShortArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.44 1.5 12.5.44l5.06 5.06-5.06 5.06-1.06-1.06 3.25-3.25H.5v-1.5h14.19L11.44 1.5Z","fill":"currentColor"}));
}

ShortArrow.defaultProps = {"width":"18","height":"11","fill":"none"};

module.exports = ShortArrow;

ShortArrow.default = ShortArrow;
